<div class="content">
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.ACTION"
    [dataService]="operatorsSelectorService"
    [formControl]="operationControl"
    [supportDataPassing]="false"
    [isRequired]="true"
    [multiple]="false"
  ></automata-automation-replacement-chips>
  <div class="operation-description" *ngIf="stringOperationDescriptions.get(operationControl.value) as description">
    {{ description | translate }}
  </div>
  <ng-container [ngSwitch]="operationControl.value">
    <!-- single input forms here -->
    <div *ngSwitchCase="StringOperationUppercase">
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.INPUT_TEXT' | translate }}</glxy-label>
        <input matInput [formControl]="$any(operationFormControls[operationControl.value])" id="value-uppercase" />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable('value-uppercase', $any(operationFormControls[operationControl.value]), $event)
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
    </div>
    <div *ngSwitchCase="StringOperationCapitalize">
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.INPUT_TEXT' | translate }}</glxy-label>
        <input matInput [formControl]="$any(operationFormControls[operationControl.value])" id="value-capitalize" />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable('value-capitalize', $any(operationFormControls[operationControl.value]), $event)
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
    </div>
    <div *ngSwitchCase="StringOperationLowerCase">
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.INPUT_TEXT' | translate }}</glxy-label>
        <input matInput [formControl]="$any(operationFormControls[operationControl.value])" id="value-lowercase" />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable('value-lowercase', $any(operationFormControls[operationControl.value]), $event)
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
    </div>
    <div *ngSwitchCase="StringOperationExtractEmail">
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.INPUT_TEXT' | translate }}</glxy-label>
        <input matInput [formControl]="$any(operationFormControls[operationControl.value])" id="value-email" />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable('value-email', $any(operationFormControls[operationControl.value]), $event)
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
    </div>

    <!-- complex forms below -->
    <div *ngSwitchCase="StringOperationDefaultValue">
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.INPUT_TEXT' | translate }}</glxy-label>
        <input
          matInput
          [formControl]="$any(operationFormControls[StringOperationDefaultValue]).controls.value"
          id="value-default-value"
        />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable(
              'value-default-value',
              $any(operationFormControls[operationControl.value]).controls.value,
              $event
            )
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
      <glxy-form-field [required]="false">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.OPERATORS.DEFAULT_VALUE' | translate }}</glxy-label>
        <input
          matInput
          [formControl]="$any(operationFormControls[StringOperationDefaultValue]).controls.defaultValue"
          id="value-default-default"
        />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable(
              'value-default-default',
              $any(operationFormControls[operationControl.value]).controls.defaultValue,
              $event
            )
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
    </div>

    <div *ngSwitchCase="StringOperationReplaceAll">
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.INPUT_TEXT' | translate }}</glxy-label>
        <input
          matInput
          [formControl]="$any(operationFormControls[StringOperationReplaceAll]).controls.value"
          id="value-replace-value"
        />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable(
              'value-replace-value',
              $any(operationFormControls[operationControl.value]).controls.value,
              $event
            )
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.TO_REPLACE' | translate }}</glxy-label>
        <input
          matInput
          [formControl]="$any(operationFormControls[StringOperationReplaceAll]).controls.toReplace"
          id="value-replace-to-replace"
        />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable(
              'value-replace-to-replace',
              $any(operationFormControls[operationControl.value]).controls.toReplace,
              $event
            )
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.REPLACE_WITH' | translate }}</glxy-label>
        <input
          matInput
          [formControl]="$any(operationFormControls[StringOperationReplaceAll]).controls.toReplaceWith"
          id="value-replace-to-replace-with"
        />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable(
              'value-replace-to-replace-with',
              $any(operationFormControls[operationControl.value]).controls.toReplaceWith,
              $event
            )
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
    </div>
    <div *ngSwitchCase="StringOperationTableLookup">
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.INPUT_TEXT' | translate }}</glxy-label>
        <input
          matInput
          [formControl]="$any(operationFormControls[StringOperationTableLookup]).controls.value"
          id="value-table-value"
        />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable(
              'value-table-value',
              $any(operationFormControls[operationControl.value]).controls.value,
              $event
            )
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
      <automata-key-value-input
        keyLabel="COMMON.KEY"
        valueLabel="COMMON.VALUE"
        title="AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.TABLE_DATA"
        [formArray]="$any(operationFormControls[StringOperationTableLookup]).controls.tableData"
      ></automata-key-value-input>
      <glxy-form-field>
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.OPERATORS.DEFAULT_VALUE' | translate }}</glxy-label>
        <glxy-hint>{{ 'AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.DEFAULT_VALUE_DESCRIPTION' | translate }}</glxy-hint>
        <input
          matInput
          [formControl]="$any(operationFormControls[StringOperationTableLookup]).controls.defaultValue"
          id="value-table-default-value"
        />
        <automata-automation-variable-menu
          [supportedDataTypes]="allDataTypes"
          (variableSelected)="
            insertVariable(
              'value-table-default-value',
              $any(operationFormControls[operationControl.value]).controls.defaultValue,
              $event
            )
          "
          matSuffix
          useGalaxyCompat="true"
          class="dynamic-content-icon"
        ></automata-automation-variable-menu>
      </glxy-form-field>
    </div>
    <div *ngSwitchDefault></div>
  </ng-container>
</div>
